import styled from 'styled-components';

import { borderColor, dangerColor } from '../../../lib/theme';

export const FormBody = styled.div`
  padding: 16px 20px 0;
`;

export const Footer = styled.div`
  position: sticky;
  bottom: 0;
  background: #fff;
  border-top: 1px solid ${borderColor};
  padding: 12px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const RecipientCount = styled.span`
  font-weight: 500;
`;

export const UnreachableWarning = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  /* dangerColor reads cleanly against the footer's white background; the
     theme's warnColor (#ffcf33) is too pale for text use. */
  color: ${dangerColor};
  font-size: 12px;
  line-height: 1.3;

  svg { font-size: 14px; }
`;

export const SectionDivider = styled.hr`
  border: none;
  border-top: 1px solid ${borderColor};
  margin: 20px 0 8px;
`;
